import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'smartCollectionController';
export default {
    /**
     * 智能催收发送短信查询
     */
    getAllCollectionCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllCollectionCaseInfo',
        type: requestType.Get
    },
    /**
     * 根据联系人关系和案件
     */
    getPersonalContacts: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getPersonalContacts',
        type: requestType.Post
    },
    /**
     * 短信批量发送
     */
    batchSendMessage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'batchSendMessage',
        type: requestType.Post
    },
    /**
     * 邮件批量发送
     */
    batchSendMail: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'batchSendMail',
        type: requestType.Post
    },
    /**
     * 获取邮件发送列表
     */
    getMailPersonal: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getMailPersonal',
        type: requestType.Post
    }
};
